import { Widget, WidgetHeader, WidgetBody } from "../../ui/Widget"
import { NeutralButton } from "../../common/Buttons"
import InfoItem from "../../common/InfoItem"
import useStore from "../../../store"
import { Flex } from "@chakra-ui/react"

export default function UploadQueueSummary() {
  const { requestQueue, retryRequest } = useStore()

  const handleRetryAll = () => {
    const failedRequests = requestQueue.filter((request) => request.status === 'failed')
    failedRequests.forEach(request => retryRequest(request.id))
  }

  if (requestQueue.length === 0) {
    return null
  }

  return (
    <Widget>
      <WidgetHeader title="Unit Upload Queue" />
      <WidgetBody>
        <Flex flexDirection="column" gap={2}>
          <Flex gap={2}>
            <InfoItem title="Total Requests">
              {requestQueue.length}
            </InfoItem>
            <InfoItem title="Pending Requests">
              {requestQueue.filter(request => request.status === 'pending').length}
            </InfoItem>
            <InfoItem title="Failed Requests">
              {requestQueue.filter(request => request.status === 'failed').length}
            </InfoItem>
          </Flex>
          <NeutralButton
            text="Retry All"
            onClick={handleRetryAll}
            disabled={requestQueue.filter((request) => request.status === 'failed').length === 0}
          />
        </Flex>
      </WidgetBody>
    </Widget>
  )
}